/*eslint-disable*/
import Flickity from 'flickity'
import vsbl from 'vsbl'
// FIXME: When importing flickity globally on theme.liquid it breaks importing it within single files!
//        see: https://github.com/metafizzy/flickity/issues/484

export default press => {
  const arrows = press.querySelector('.js-carousel-arrows')
  const leftArrow = press.querySelector('.js-carousel-left')
	const rightArrow = press.querySelector('.js-carousel-right')
	
	//change bottom line color of 'learn more section' on mobile so it matches bottom review line
	const learnMoreMobile = document.querySelector('.learn-more-mobile')
	if (learnMoreMobile) {
		learnMoreMobile.children[1].classList.add("review-line-color")
	}

  const slideshow = press.querySelector('.js-press-slider')

  vsbl(press)(() => {
    press.classList.add('is-visible')
  })

  if (press) {
    const flkty = new Flickity(slideshow, {
      contain: true,
      prevNextButtons: false,
      cellAlign: 'center',
      pageDots: true,
      imagesLoaded: true,
      percentPosition: false,
      autoPlay: 4000, 
      wrapAround: true,
      adaptiveHeight: true
    })
    flkty.on('dragStart', (event, pointer) => { document.ontouchmove = e => e.preventDefault() })
    flkty.on('dragEnd', (event, pointer) => { document.ontouchmove = e => true })
    arrows.classList.remove('hidden')
    leftArrow.addEventListener('click', () => flkty.previous())
    rightArrow.addEventListener('click', () =>flkty.next())
    setTimeout(() => {
      flkty.resize()
    }, 1500)
  } 
}



// WEBPACK FOOTER //
// ./src/scripts/components/pdp-press-slider.js